import axios from "axios";

export default {
    namespaced: true,
    state() {
        return {
            allMaterials: [],
            allMaterialFolders:[]
        };
    },
    getters: {
        allMaterials: (state) => state.allMaterials,
        allMaterialFolders: (state) => state.allMaterialFolders,
    },
    actions: {
        async getAllMaterials({ commit },folderId = null) {
            //fetch list of all materials
            try {
                let url = folderId ? "/api/get-all-materials/"+folderId : "/api/get-all-materials";
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get(url).then((data) => {
                    commit("setAllMaterials", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async getAllMaterialFolders({ commit }) {
            //fetch list of all materials
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-material-folders").then((data) => {
                    commit("setAllMaterialFolders", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async addMaterial({ commit, dispatch }, request) {
            //add material
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/store-material", request)
                    .then((data) => {
                        dispatch("getAllMaterials");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async deleteMaterial({ commit, dispatch }, request) {
            //delete material
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/delete-material", request)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async deleteMaterialFolder({ commit, dispatch }, request) {
            //delete material
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/delete-material-folder", request)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
    },
    mutations: {
        setAllMaterials(state, allMaterials) {
            state.allMaterials = allMaterials;
        },
        setAllMaterialFolders(state, allMaterialFolders) {
            state.allMaterialFolders = allMaterialFolders;
        },
    },
};
